import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import styles from "./styles.scss";

function MaterialResourceForm({ formData, edit }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.materialResourceForm}>
      <div className={styles.row}>
        <div className={styles.group}>
          <h3 className={styles.label}>
            {t("materialResourceForm.nameTitle")}
          </h3>
          <input
            className={styles.input}
            placeholder={t("materialResourceForm.namePlaceholder")}
            value={formData.name}
            onChange={({ target }) => edit({ ...formData, name: target.value })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <h3 className={styles.label}>
          {t("materialResourceForm.descriptionTitle")}
        </h3>
        <textarea
          className={styles.textArea}
          value={formData.description}
          onChange={({ target }) =>
            edit({ ...formData, description: target.value })
          }
        />
      </div>
    </div>
  );
}

export { MaterialResourceForm };
